import { Card, CardContent } from "@/components/ui/card"
import Header from "../components/Header"
import Footer from "../components/Footer"
import LoginModal from "../components/LoginModal"
import ForgetPassword from '../components/ForgetPassword'
import { useState } from "react"
import { TrialFormDialog } from '@/components/common/Trial/TrialFormDialog';
import { ArrowButton } from '@/components/common/ArrowButton'

export default function IDataLandingPage() {

  const [ loginStatus, setLoginStatus ] = useState(false);

  const [ forgetStatus, setForgetStatus ] = useState(false);

  const [ trialFormStatus, setTrialFormStatus ] = useState(false);

  const handleForgotPasswordClick = () => {
    setLoginStatus(false)
    setForgetStatus(true)
  }


  return (
    <div className="min-h-screen bg-white">
      <Header></Header>
      {/* Hero Section */}
      <section className="relative text-white overflow-hidden h-[624px] bg-center bg-no-repeat bg-cover
      bg-[url('@/assets/images/inner-banner.png')]">
        {/* Data Visualization Graphics */}
        <div className="absolute inset-0">
          
        </div>

        <div className="relative container container-max-w mx-auto px-4 h-full flex items-center">
          <div className="max-w-2xl">
            <h1 className="text-[60px] font-bold mb-6">
              iData <span>{"<GO>"}</span>
            </h1>
            <p className="text-xl text-gray-300 mb-8 leading-relaxed">
              Log in to your account to discover, acquire
              <br></br>
              and immediately access data
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <ArrowButton onClick={() => setLoginStatus(true)} text={'Log in'} className="w-[164px] h-[62px] text-[24px]"></ArrowButton>
              <ArrowButton
              onClick={() => setTrialFormStatus(true)}
              text={'Sign up'}
              textClassName={"mr-[10px]"}
              className="w-[164px] h-[62px] text-[24px] bg-transparent border border-[#fff] hover:text-[#000] hover:bg-[#fff]"></ArrowButton>
            </div>
          </div>
        </div>
      </section>

      {/* Get Started Section */}
      <section className="pt-[82px] pb-[132px] bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-[40px] text-[#161616] mb-[64px]">Get Started Today</h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {/* Ready-To-Use Data */}
            <Card className="bg-white hover:shadow-lg transition-shadow h-[240px] bg-[#F3F3F3] hover:bg-[#e8e8e8] border-none">
              <CardContent className="p-6">
                <div className="flex items-start justify-between mb-4">
                  <svg width="51px" height="40px" viewBox="0 0 51 40" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                      <title>三列</title>
                      <g id="页面-2" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round">
                          <g id="内层登陆页" transform="translate(-353.000000, -832.000000)" stroke-width="2">
                              <g id="三列" transform="translate(354.000000, 833.000000)">
                                  <path d="M12.8535884,38 L8.14641165,38 C6.961239,38 6,37.0613009 6,35.9039192 L6,11.0960808 C6,9.93869909 6.961239,9 8.14641165,9 L12.8535884,9 C14.038761,9 15,9.93869909 15,11.0960808 L15,35.9039192 C15,37.0613009 14.038761,38 12.8535884,38 Z" id="Stroke-1" stroke="#161616"></path>
                                  <path d="M26.8414015,37 L22.1585985,37 C20.9673324,37 20,36.0545323 20,34.8868647 L20,2.1131353 C20,0.94695901 20.9673324,0 22.1585985,0 L26.8414015,0 C28.0341909,0 29,0.94695901 29,2.1131353 L29,34.8868647 C29,36.0545323 28.0341909,37 26.8414015,37 Z" id="Stroke-3" stroke="#0066FF"></path>
                                  <path d="M41.8547486,38 L37.1452514,38 C35.9598781,38 35,37.0335349 35,35.8419186 L35,21.1565498 C35,19.9649335 35.9598781,19 37.1452514,19 L41.8547486,19 C43.0401219,19 44,19.9649335 44,21.1565498 L44,35.8419186 C44,37.0335349 43.0401219,38 41.8547486,38 Z" id="Stroke-5" stroke="#161616"></path>
                                  <line x1="0" y1="38" x2="49" y2="38" id="Stroke-7" stroke="#161616"></line>
                              </g>
                          </g>
                      </g>
                  </svg>
                </div>
                <h3 className="text-[22px] text-[#161616] font-bold">Ready-To-Use Data</h3>
                <ul className="space-y-1 text-[16px] text-[#4d4d4d] mt-[10px]">
                  <li>Discover datasets</li>
                  <li>Download & test</li>
                  <li>Acquire & purchase</li>
                </ul>
              </CardContent>
            </Card>

            {/* Inventory Management */}
            <Card className="bg-white hover:shadow-lg transition-shadow h-[240px] bg-[#F3F3F3] hover:bg-[#e8e8e8] border-none">
              <CardContent className="p-6">
                <div className="flex items-start justify-between mb-4">
                  <svg width="40px" height="41px" viewBox="0 0 40 41" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                      <title>书</title>
                      <g id="页面-2" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                          <g id="内层登陆页" transform="translate(-994.000000, -832.000000)">
                              <g id="书" transform="translate(995.000000, 833.000000)">
                                  <path d="M0,0 L30,0 L30,16.7560641 C30,16.7560641 10.5971541,15.261244 17.6084396,36 L0,36 L0,0 Z" id="Stroke-1" stroke="#161616" stroke-width="2" stroke-linecap="round"></path>
                                  <line x1="4" y1="5.5" x2="19" y2="5.5" id="Stroke-3" stroke="#161616" stroke-width="2"></line>
                                  <line x1="4" y1="12.5" x2="15" y2="12.5" id="Stroke-5" stroke="#161616" stroke-width="2"></line>
                                  <line x1="4" y1="18.5" x2="12" y2="18.5" id="Stroke-7" stroke="#161616" stroke-width="2"></line>
                                  <path d="M36,28.4992305 C36,31.1092644 34.6657433,33.4084334 32.6420437,34.7519237 C31.4570637,35.5398584 30.0320098,36 28.4992305,36 C24.3579563,36 21,32.6405048 21,28.4992305 C21,24.3579563 24.3579563,21 28.4992305,21 C32.6405048,21 36,24.3579563 36,28.4992305 Z" id="Stroke-9" stroke="#0066FF" stroke-width="3"></path>
                                  <line x1="32" y1="33" x2="37" y2="39" id="Stroke-11" stroke="#0066FF" stroke-width="3"></line>
                              </g>
                          </g>
                      </g>
                  </svg>
                </div>
                <h3 className="text-[22px] text-[#161616] font-bold">Inventory Management</h3>
                <ul className="space-y-1 text-[16px] text-[#4d4d4d] mt-[10px]">
                  <li>View subscriptions</li>
                  <li>Browse categories</li>
                  <li>Filter content</li>
                </ul>
              </CardContent>
            </Card>

            {/* Data Marketplace */}
            <Card className="bg-white hover:shadow-lg transition-shadow h-[240px] bg-[#F3F3F3] hover:bg-[#e8e8e8] border-none">
              <CardContent className="p-6">
                <div className="flex items-start justify-between mb-4">
                  <svg width="43px" height="46px" viewBox="0 0 43 46" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                      <title>03-data storage</title>
                      <g id="页面-2" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                          <g id="内层登陆页" transform="translate(-355.000000, -1087.000000)" stroke-width="2">
                              <g id="03-data-storage" transform="translate(356.000000, 1088.000000)">
                                  <path d="M0,17.6651809 C0,17.6651809 16.8448986,26.5960153 40.2108583,17.6651809" id="Stroke-1" stroke="#0066FF"></path>
                                  <path d="M0,26.5961093 C0,26.5961093 15.5638247,38.0890914 40.2108583,26.5961093" id="Stroke-3" stroke="#0066FF"></path>
                                  <path d="M40.2108583,6.10626399 C40.2108583,9.47919416 31.2094802,12.212528 20.1058994,12.212528 C9.00137806,12.212528 0,9.47919416 0,6.10626399 C0,2.73333382 9.00137806,0 20.1058994,0 C31.2094802,0 40.2108583,2.73333382 40.2108583,6.10626399 Z" id="Stroke-5" stroke="#161616"></path>
                                  <path d="M0,6.10626399 L0,37.6298989 C0,37.6298989 15.1443248,49.7126264 40.2108583,37.6298989 L40.2108583,6.10626399" id="Stroke-7" stroke="#161616"></path>
                              </g>
                          </g>
                      </g>
                  </svg>
                </div>
                <h3 className="text-[22px] text-[#161616] font-bold">Data Marketplace</h3>
                <ul className="space-y-1 text-[16px] text-[#4d4d4d] mt-[10px]">
                  <li>Browse new/upgraded</li>
                  <li>Download samples</li>
                  <li>Subscribe & access datasets</li>
                </ul>
              </CardContent>
            </Card>

            {/* Get Started Today */}
            <Card className="bg-white hover:shadow-lg transition-shadow
            h-[240px] bg-[#F3F3F3] hover:bg-[#e8e8e8] border-none cursor-pointer group"
            onClick={() => setTrialFormStatus(true)}>
              <CardContent className="p-6">
                <div className="flex items-start justify-between mb-4">
                  <svg width="39px" height="34px" viewBox="0 0 39 34" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                      <title>箭头大1备份 2</title>
                      <g id="页面-2" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                          <g id="内层登陆页" transform="translate(-994.000000, -1088.000000)" stroke="#161616" className="group-hover:stroke-[#0066FF]" stroke-width="3">
                              <g id="编组-6备份" transform="translate(968.000000, 1064.000000)">
                                  <g id="箭头大1备份-2" transform="translate(26.000000, 26.000000)">
                                      <line x1="4.46269025e-14" y1="15" x2="32.9816126" y2="15" id="路径-3"></line>
                                      <polyline id="路径" transform="translate(21.202465, 15.000000) rotate(-45.000000) translate(-21.202465, -15.000000) " points="31.8090669 4.39339828 30.6257831 24.4233179 10.5958635 25.6066017"></polyline>
                                  </g>
                              </g>
                          </g>
                      </g>
                  </svg>
                </div>
                <h3 className="text-[22px] text-[#161616] font-bold group-hover:text-[#0066FF]">Get Started Today</h3>
                <ul className="space-y-1 text-[16px] text-[#4d4d4d] mt-[10px]">
                  <li>Clients: Request access</li>
                  <li>Request demo</li>
                  <li>Contact sales</li>
                </ul>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>
      <Footer></Footer>

      <LoginModal open={loginStatus} onOpenChange={setLoginStatus} onForgotPasswordClick={handleForgotPasswordClick}></LoginModal>
      <ForgetPassword open={forgetStatus} onOpenChange={setForgetStatus} ></ForgetPassword>
      <TrialFormDialog open={trialFormStatus} onOpenChange={setTrialFormStatus}></TrialFormDialog>
    </div>
  )
}
